// extracted by mini-css-extract-plugin
export const errorMessage = "input-module--errorMessage--1624s";
export const inputBox = "input-module--inputBox--39AXH";
export const high = "input-module--high--2aMG_";